import React, { Component, Fragment } from "react";
import axios from "../../containers/api";
import Config from "../../constants/config"; // TODO: adjust to your actual config path/depth
import {
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import "./reserve-journey.scss";

/* ------------------------------------------------------------------ */
/*  helpers                                                            */
/* ------------------------------------------------------------------ */
const toEnglishNumbers = (str) => {
  if (!str) return str;
  const persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  const arabic = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
  return String(str).replace(/[۰-۹٠-٩]/g, (ch) => {
    let idx = persian.indexOf(ch);
    if (idx === -1) idx = arabic.indexOf(ch);
    return idx === -1 ? ch : idx;
  });
};

const fileUrl = (fileName) =>
  Config.url + "UploadFile/" + toEnglishNumbers(fileName);

/* ------------------------------------------------------------------ */
/*  Line-icon set — single stroke, rounded caps, 24x24 viewBox         */
/* ------------------------------------------------------------------ */
const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {children}
  </svg>
);

const icons = {
  reserve: (
    <Icon>
      <path
        d="M4 8.5 12 4l8 4.5v8L12 21l-8-4.5v-8Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M4 8.5 12 13l8-4.5M12 13v8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </Icon>
  ),
  draft: (
    <Icon>
      <path
        d="M6 3.5h8l4 4V20a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 6 20V4a.5.5 0 0 1 .5-.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M14 3.5V8h4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.5h6M9 15.5h6M9 9.5h2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </Icon>
  ),
  bargiri: (
    <Icon>
      <path
        d="M2.5 16.5V8h9v8.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11h4l3 3v2.5h-7V11Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle
        cx="6"
        cy="18.5"
        r="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <circle
        cx="16"
        cy="18.5"
        r="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M7 4.5v3.5M4.2 6.2h5.6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </Icon>
  ),
  accept: (
    <Icon>
      <path
        d="M12 3.5 19 6v6c0 4.2-2.9 7-7 8.5-4.1-1.5-7-4.3-7-8.5V6l7-2.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="m8.7 12.2 2.3 2.3 4.3-4.5"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  ),
  bol: (
    <Icon>
      <path
        d="M6 3.5h8l4 4V20a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 6 20V4a.5.5 0 0 1 .5-.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M14 3.5V8h4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="m9 13.3 1.8 1.8 3.2-3.6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  ),
  deliver: (
    <Icon>
      <path
        d="M2.5 16.5V8h9v8.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11h4l3 3v2.5h-7V11Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle
        cx="6"
        cy="18.5"
        r="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <circle
        cx="16"
        cy="18.5"
        r="1.6"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M9.2 4.8 7 7l2.2 2.2"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  ),
  canceled: (
    <Icon>
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="m8.5 8.5 7 7m0-7-7 7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </Icon>
  ),
  truckMarker: (
    <Icon>
      <path
        d="M2 15.5V6.8h8.6v8.7"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinejoin="round"
      />
      <path
        d="M10.6 10h3.8l2.8 2.8v2.7h-6.6V10Z"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinejoin="round"
      />
      <circle cx="5.6" cy="17.4" r="1.7" fill="currentColor" />
      <circle cx="15.2" cy="17.4" r="1.7" fill="currentColor" />
    </Icon>
  ),
  image: (
    <Icon>
      <rect
        x="3.5"
        y="4.5"
        width="17"
        height="15"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <circle
        cx="8.5"
        cy="9.5"
        r="1.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="m5 17 5-5 3 3 3-4 4 6"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  ),
  close: (
    <Icon>
      <path
        d="m6 6 12 12M18 6 6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  ),
};

/* ------------------------------------------------------------------ */
/*  Cycle definition — mirrors ReserveStatus enum, Printed excluded    */
/*  fileType links a step to its reserveFileModel[].type (0=حواله,     */
/*  1=بارنامه) so the matching images render right under that node.    */
/* ------------------------------------------------------------------ */
const STEPS = [
  {
    status: 1,
    key: "Reserved",
    title: "رزرو بار",
    waitingLabel: null,
    fileType: null,
  },
  {
    status: 3,
    key: "UploadDraft",
    title: "صدور حواله",
    waitingLabel: "در انتظار صدور حواله توسط شرکت",
    fileType: 0,
  },
  {
    status: 6,
    key: "Bargiri",
    title: "بارگیری",
    waitingLabel: "در انتظار تایید صاحب کالا",
    fileType: null,
  },
  {
    status: 7,
    key: "AcceptBargiri",
    title: "تایید بارگیری",
    waitingLabel: "در انتظار صدور بارنامه توسط شرکت",
    fileType: null,
  },
  {
    status: 4,
    key: "UploadBillOfLading",
    title: "صدور بارنامه",
    waitingLabel: null,
    fileType: 1,
  },
  {
    status: 5,
    key: "DeliverCargo",
    title: "تحویل بار",
    waitingLabel: null,
    fileType: null,
  },
];

const FILE_TYPE_LABEL = { 0: "تصاویر حواله", 1: "تصاویر بارنامه" };

const iconFor = {
  Reserved: icons.reserve,
  UploadDraft: icons.draft,
  Bargiri: icons.bargiri,
  AcceptBargiri: icons.accept,
  UploadBillOfLading: icons.bol,
  DeliverCargo: icons.deliver,
};

/* Road geometry — RTL: step 0 sits on the right, last step on the left */
const buildGeometry = (count) => {
  const width = 1040;
  const marginX = 60;
  const usable = width - marginX * 2;
  const spacing = usable / (count - 1);
  const yWave = [150, 88, 150, 88, 150, 88];
  const points = Array.from({ length: count }, (_, i) => ({
    x: width - marginX - spacing * i,
    y: yWave[i % yWave.length],
  }));
  let d = `M ${points[0].x} ${points[0].y}`;
  for (let i = 1; i < points.length; i++) {
    const p0 = points[i - 1];
    const p1 = points[i];
    const midX = (p0.x + p1.x) / 2;
    d += ` C ${midX} ${p0.y}, ${midX} ${p1.y}, ${p1.x} ${p1.y}`;
  }
  return { points, path: d, width, height: 220 };
};

const GEOMETRY = buildGeometry(STEPS.length);

const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("fa-IR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(iso));
  } catch (e) {
    return iso;
  }
};

export default class ReserveJourney extends Component {
  state = {
    data: null,
    loading: true,
    error: null,
    sendCodeModal: false,
    activeCode: "",
    sendingCode: false,
    verifying: false,
    bargiriLoading: false,
    cancelLoading: false,
    lightboxImage: null,
  };

  componentDidMount() {
    this.fetchReserve();
  }

  fetchReserve = () => {
    this.setState({ loading: true, error: null });
    axios
      .get(
        `api/v1/DriverReserve/GetByDriverToFreighterId?DriverToFreighterId=${this.props.driverToFreighterId}`,
      )
      .then((res) => {
        this.setState({ data: res.data.data, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: "مشکلی در دریافت اطلاعات رزرو پیش آمد",
        });
        console.log(error.response);
      });
  };

  notify = (message, type = "success") => {
    if (this.props.showAlert) this.props.showAlert(message, type);
  };

  handleCancel = () => {
    const { data } = this.state;
    if (!data) return;
    this.setState({ cancelLoading: true });
    axios
      .post("/api/v1/DriverReserve/CancelReserve", {
        Id: data.id,
        CancelType: false,
      })
      .then((res) => {
        this.setState({ cancelLoading: false });
        this.notify(
          (res.data && res.data.data && res.data.data.message) || "رزرو لغو شد",
          "success",
        );
        this.fetchReserve();
      })
      .catch((error) => {
        this.setState({ cancelLoading: false });
        this.notify("لغو رزرو با خطا مواجه شد", "error");
        console.log(error.response);
      });
  };

  handleBargiri = () => {
    const { data } = this.state;
    if (!data) return;
    this.setState({ bargiriLoading: true });
    axios
      .post("/api/v1/DriverReserve/BargiriReserve", {
        Id: data.id,
        Type: 0,
      })
      .then((res) => {
        this.setState({ bargiriLoading: false });
        this.notify(
          (res.data && res.data.data && res.data.data.message) ||
            "بارگیری اعلام شد",
          "success",
        );
        this.fetchReserve();
      })
      .catch((error) => {
        this.setState({ bargiriLoading: false });
        this.notify("اعلام بارگیری با خطا مواجه شد", "error");
        console.log(error.response);
      });
  };

  openDeliveryModal = () =>
    this.setState({ sendCodeModal: true, activeCode: "" });
  closeDeliveryModal = () => this.setState({ sendCodeModal: false });

  sendActivationCode = () => {
    const { data } = this.state;
    if (!data) return;
    this.setState({ sendingCode: true });
    axios
      .post(
        `api/v1/Assistant/DriverReserveSendActivatinCode?DriverReserveId=${data.id}`,
      )
      .then((res) => {
        this.setState({ sendingCode: false });
        this.notify(
          (res.data && res.data.data && res.data.data.message) ||
            "کد برای گیرنده ارسال شد",
          "success",
        );
      })
      .catch((error) => {
        this.setState({ sendingCode: false });
        this.notify("ارسال کد با خطا مواجه شد", "error");
        console.log(error.response);
      });
  };

  checkActivationCode = () => {
    const { data, activeCode } = this.state;
    if (!activeCode) {
      this.notify("لطفا کد ارسالی را وارد کنید", "error");
      return;
    }
    this.setState({ verifying: true });
    axios
      .post("api/v1/Assistant/CheckActivatinForUpdateReserveStatus", {
        code: activeCode,
        DriverReserveId: data.id,
      })
      .then((res) => {
        this.setState({ verifying: false, sendCodeModal: false });
        this.notify(
          (res.data && res.data.data && res.data.data.message) ||
            "تحویل بار ثبت شد",
          "success",
        );
        this.fetchReserve();
      })
      .catch((error) => {
        this.setState({ verifying: false });
        this.notify("کد وارد شده معتبر نیست", "error");
        console.log(error.response);
      });
  };

  renderRoad(currentIndex) {
    const { points, path, width, height } = GEOMETRY;
    const truck = points[Math.max(currentIndex, 0)];

    return (
      <div className="rj-road-wrap">
        <svg
          className="rj-road-svg"
          viewBox={`0 0 ${width} ${height}`}
          preserveAspectRatio="xMidYMid meet"
        >
          <path d={path} className="rj-road-base" />
          <path d={path} className="rj-road-lane" />
          <path
            d={path}
            className="rj-road-progress"
            style={{
              strokeDasharray: 2000,
              strokeDashoffset:
                currentIndex <= 0
                  ? 2000
                  : 2000 - (2000 * currentIndex) / (STEPS.length - 1),
            }}
          />
          {points.map((p, i) => {
            const step = STEPS[i];
            const state =
              currentIndex < 0
                ? "pending"
                : i < currentIndex
                  ? "done"
                  : i === currentIndex
                    ? "active"
                    : "pending";
            return (
              <g
                key={step.key}
                className={`rj-node rj-node--${state}`}
                transform={`translate(${p.x}, ${p.y})`}
              >
                <circle r="26" className="rj-node-halo" />
                <circle r="19" className="rj-node-circle" />
                <g transform="translate(-11,-11)" className="rj-node-icon">
                  {iconFor[step.key]}
                </g>
                <text y="46" textAnchor="middle" className="rj-node-label">
                  {step.title}
                </text>
              </g>
            );
          })}
          {currentIndex >= 0 && (
            <g
              className="rj-truck"
              transform={`translate(${truck.x}, ${truck.y - 46})`}
            >
              <g transform="translate(-13,-13)">{icons.truckMarker}</g>
            </g>
          )}
        </svg>
      </div>
    );
  }

  renderActions(step) {
    const { bargiriLoading, cancelLoading, sendingCode } = this.state;
    if (!step) return null;

    const cancelBtn = (
      <Button
        key="cancel"
        outline
        color="danger"
        size="sm"
        disabled={cancelLoading}
        onClick={this.handleCancel}
      >
        {cancelLoading ? "در حال لغو..." : "لغو رزرو"}
      </Button>
    );

    if (step.key === "Reserved") {
      return <div className="rj-actions">{cancelBtn}</div>;
    }
    if (step.key === "UploadDraft") {
      return (
        <div className="rj-actions">
          <Button
            color="warning"
            size="sm"
            disabled={bargiriLoading}
            onClick={this.handleBargiri}
          >
            {bargiriLoading ? "در حال ثبت..." : "اعلام بارگیری"}
          </Button>
          {cancelBtn}
        </div>
      );
    }
    if (step.key === "UploadBillOfLading") {
      return (
        <div className="rj-actions">
          <Button
            color="success"
            size="sm"
            disabled={sendingCode}
            onClick={this.openDeliveryModal}
          >
            درخواست تحویل بار
          </Button>
        </div>
      );
    }
    if (step.key === "DeliverCargo") {
      return <div className="rj-done-msg">✅ تحویل بار با موفقیت ثبت شد</div>;
    }
    if (step.waitingLabel) {
      return <div className="rj-waiting">{step.waitingLabel}</div>;
    }
    return null;
  }

  renderFiles(files) {
    if (!files || files.length === 0) return null;
    const groups = { 0: [], 1: [] };
    files.forEach((f) => {
      if (groups[f.type]) groups[f.type].push(f);
      else if (f.type === 0 || f.type === 1) groups[f.type].push(f);
    });

    const sections = [0, 1].filter((t) => groups[t] && groups[t].length > 0);
    if (sections.length === 0) return null;

    return (
      <div className="rj-files">
        {sections.map((type) => (
          <div className="rj-files-group" key={type}>
            <div className="rj-files-group-title">
              <span className="rj-files-icon">{icons.image}</span>
              {FILE_TYPE_LABEL[type]}
            </div>
            <div className="rj-files-thumbs">
              {groups[type].map((f) => (
                <button
                  type="button"
                  key={f.id}
                  className="rj-thumb"
                  onClick={() =>
                    this.setState({ lightboxImage: fileUrl(f.fileName) })
                  }
                >
                  <img src={fileUrl(f.fileName)} alt={FILE_TYPE_LABEL[type]} />
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const {
      data,
      loading,
      error,
      sendCodeModal,
      activeCode,
      sendingCode,
      verifying,
      lightboxImage,
    } = this.state;

    if (loading) {
      return (
        <Card className="rj-card">
          <CardBody className="rj-loading">
            در حال بارگذاری رزرو فعال...
          </CardBody>
        </Card>
      );
    }

    if (error || !data) {
      return (
        <Card className="rj-card">
          <CardBody className="rj-empty">
            {error || "رزرو فعالی برای نمایش وجود ندارد"}
          </CardBody>
        </Card>
      );
    }

    const isCanceled = data.status === 0;
    const currentIndex = STEPS.findIndex((s) => s.status === data.status);
    const currentStep = currentIndex >= 0 ? STEPS[currentIndex] : null;

    return (
      <Card className="rj-card">
        <CardBody>
          <div className="rj-header">
            <div className="rj-route">
              <span className="rj-route-city">{data.cargoSource}</span>
              <span className="rj-route-arrow">←</span>
              <span className="rj-route-city">{data.cargoDestination}</span>
            </div>
            <div className="rj-meta">
              <span>{data.kalaDesc}</span>
              <span className="rj-meta-dot">·</span>
              <span className="rj-meta-mono">#{data.driverToFreighterId}</span>
              <span className="rj-meta-dot">·</span>
              <span className="rj-meta-mono">
                {formatDate(data.dateCreated)}
              </span>
            </div>
          </div>

          {isCanceled ? (
            <div className="rj-canceled">
              <div className="rj-canceled-icon">{icons.canceled}</div>
              <div>
                <div className="rj-canceled-title">این رزرو لغو شده است</div>
                <div className="rj-canceled-desc">{data.description}</div>
              </div>
            </div>
          ) : (
            <Fragment>
              {this.renderRoad(currentIndex)}
              {this.renderActions(currentStep)}
              {this.renderFiles(data.reserveFileModel)}
            </Fragment>
          )}

          <div className="rj-info-grid">
            <div>
              <div className="rj-info-label">شرکت حمل و نقل</div>
              <div className="rj-info-value">
                {data.transportationCompanyName || "—"}
              </div>
            </div>
            <div>
              <div className="rj-info-label">تلفن شرکت</div>
              <div className="rj-info-value rj-meta-mono">
                {data.transportationCompanyMobile || "—"}
              </div>
            </div>
            <div>
              <div className="rj-info-label">نوع بسته‌بندی</div>
              <div className="rj-info-value">{data.bastebandyName || "—"}</div>
            </div>
            <div>
              <div className="rj-info-label">کرایه</div>
              <div className="rj-info-value rj-meta-mono">
                {data.cargoRent
                  ? Number(data.cargoRent).toLocaleString("fa-IR") + " ریال"
                  : "—"}
              </div>
            </div>
          </div>
        </CardBody>

        <Modal
          isOpen={sendCodeModal}
          size="md"
          centered
          toggle={this.closeDeliveryModal}
        >
          <ModalHeader toggle={this.closeDeliveryModal}>تحویل بار</ModalHeader>
          <ModalBody>
            <p className="rj-modal-hint">
              با فشردن «ارسال کد» یک کد تایید برای گیرنده ارسال می‌شود. کد را از
              گیرنده بگیرید و در کادر زیر وارد کنید.
            </p>
            <div className="d-flex justify-content-center mb-3">
              <Button
                color="primary"
                outline
                disabled={sendingCode}
                onClick={this.sendActivationCode}
              >
                {sendingCode ? "در حال ارسال..." : "ارسال کد"}
              </Button>
            </div>
            <FormGroup>
              <Label>کد دریافتی از گیرنده</Label>
              <Input
                value={activeCode}
                onChange={(e) => this.setState({ activeCode: e.target.value })}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.closeDeliveryModal}>
              انصراف
            </Button>
            <Button
              color="primary"
              disabled={verifying}
              onClick={this.checkActivationCode}
            >
              {verifying ? "در حال بررسی..." : "تحویل بار"}
            </Button>
          </ModalFooter>
        </Modal>

        {lightboxImage && (
          <div
            className="rj-lightbox"
            onClick={() => this.setState({ lightboxImage: null })}
          >
            <button className="rj-lightbox-close" type="button">
              {icons.close}
            </button>
            <img
              src={lightboxImage}
              alt=""
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </Card>
    );
  }
}
